import { render, staticRenderFns } from "./KimsaPasswordField.vue?vue&type=template&id=387aeb4c&scoped=true"
import script from "./KimsaPasswordField.vue?vue&type=script&lang=js"
export * from "./KimsaPasswordField.vue?vue&type=script&lang=js"
import style0 from "./KimsaPasswordField.vue?vue&type=style&index=0&id=387aeb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387aeb4c",
  null
  
)

export default component.exports